import React from 'react'
import StarRatings from '@components/ui/StarRatings'

export type YotpoStarRatingProps = {
  starRatings: {
    total_review: number
    average_score: number
  } | null
}

const YotpoStarRatings = ({ starRatings }: YotpoStarRatingProps) => {
  const averageScore = Number(starRatings?.average_score)
  const totalReviews = starRatings?.total_review

  return (
    <a href="#yotpo-reviews">
      <StarRatings averageScore={averageScore} totalReviews={totalReviews} />
    </a>
  )
}

export default YotpoStarRatings
